export const data = [
  { label: "Techie", value: "Techie" },
  { label: "Higher mathematics", value: "Higher mathematics" },
  { label: "Point", value: "Point" },
  { label: "Javascript", value: "Javascript" },
];
